import { NavbarItem } from "./navbar-item";

export default NavbarItem;